<template>
  <div class="delhtgl-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" @submit.native.prevent>
            <el-form-item label="搜索关键字">
              <el-input v-model="search" placeholder="请输入关键字" @keyup.enter.native="Search" />
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-row>
              <el-col v-loading="loading">
                <el-table
                  :data="tableData"
                  stripe
                  style="width: 100%;"
                >
                  <el-table-column
                    label="房屋标识"
                    min-width="140"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span style="color:#000;">{{ scope.row.housename }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="客户名称"
                    width="140"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.custname }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="联系电话"
                    width="140"
                    show-overflow-tooltip
                    align="center"
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.tel }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="签订人"
                    width="140"
                    show-overflow-tooltip
                    align="center"
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.username }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="签订日期"
                    width="140"
                    show-overflow-tooltip
                    align="center"
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.time }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="当前阶段"
                    width="120"
                    align="center"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===0" type="danger">未排期</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===1" type="warning">{{ scope.row.stage }}</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===9">已完成</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    width="280"
                    show-overflow-tooltip
                    align="center"
                    fixed="right"
                  >
                    <template slot-scope="scope">
                      <el-button icon="el-icon-document" size="mini" @click="viewDetail(scope.row)">查看合同</el-button>
                      <el-button icon="el-icon-position" :disabled="scope.row.mark===0" size="mini" @click="xmDetail(scope.row)">项目详情</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                />
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="合同详情"
      :visible.sync="contractVisible"
      width="40%">
      <div v-if="detail!==null">
        <table class="tcf-detail-table" cellpadding="0">
          <tr>
            <th>签订客户</th>
            <td>{{ detail.custname }}</td>
            <th>联系电话</th>
            <td>{{ detail.tel }}</td>
          </tr>
          <tr>
            <th>签订日期</th>
            <td>{{ detail.time }}</td>
            <th>经办人</th>
            <td>{{ detail.username }}</td>
          </tr>
          <tr>
            <th>合同原件</th>
            <td colspan="3">
              <el-image v-for="iurl in detail.imgurls"
                        style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
                        :src="iurl"
                        :preview-src-list="detail.imgurls">
              </el-image>
            </td>
          </tr>
          <tr>
            <th>费用清单</th>
            <td colspan="3">
              <el-table
                size="mini"
                :data="detail.costlst"
                style="width: 100%">
                <el-table-column
                  prop="name"
                  align="left"
                  label="费用名称"
                  min-width="100"
                  show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                  prop="amount"
                  label="金额"
                  align="center"
                  width="130"
                  show-overflow-tooltip>
                </el-table-column>
              </el-table>
            </td>
          </tr>
        </table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="contractVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getDealerClientSignList } from '@/api/dealer'

export default {
  name: 'delhtgl',
  data() {
    return {
      search: '',
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      contractVisible: false,
      detail: null
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getData()
  }, methods: {
    viewDetail(row) {
      this.detail = row
      this.contractVisible = true
    },
    xmDetail(row) {
      this.$router.push({ path: '/work/deldecoration/' + row.did })
    },
    Search() {
      if (this.search != null && this.search.trim() !== '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.search = ''
        this.getData()
      }
    },
    getData() {
      this.loading = true
      const data = {
        search: this.search,
        page: this.currentPage,
        limit: this.pageSize,
        delid: this.user.delid,
        userid: this.user.userid
      }
      getDealerClientSignList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    }
  }}
</script>

<style lang="scss" scoped>
.delhtgl-container{
  .group-container{
    width: 100%;
    position: relative;
    padding: 20px;
    .group-item{
      position: relative;
      padding: 9px 15px;
      background: #FFF;
      border: 1px dashed #DCDFE6;
      border-radius: 4px;
      display: inline-block;
      color: #606266;
      font-size: 12px;
      font-weight: 500;
      margin:0 20px 20px 0;
      .group-del{
        padding: 2px!important;
        font-size: 10px!important;
        position: absolute;
        right: -10px;
        top: -6px;
      }
    }
  }
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .client-sex{
            width: 16px!important;
            height: 16px!important;
            vertical-align: -4px!important;
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
